import { SMALL_IMAGE, LARGE_IMAGE, IMAGE_REPLACE } from "~/const";
import type { IPhotoItem } from "~/interfaces";

export function getSmallPhoto(item: IPhotoItem): string {
	return item.photo.replace(IMAGE_REPLACE, SMALL_IMAGE);
}

export function getLargePhoto(item: IPhotoItem): string {
	return item.photo.replace(IMAGE_REPLACE, LARGE_IMAGE);
}

export function getFileName(photoName: string): string {
	return photoName.replace(`-${IMAGE_REPLACE}`, "").replace(/.*[/]/u, "");
}

export function getDebugCaption(item: IPhotoItem, ind: number, page: number): string {
	const parts = getFileName(item.photo).split("-");
	const photoHex = parts.pop();
	const photoDec = photoHex ? parseInt(photoHex, 16) : "";

	parts.push(`(${photoDec}/${photoHex})`);

	return `${page}x${ind + 1}, ${parts.join("-")}`;
}
